import React from 'react';
//import SingleMenu from '../../../feature-module/components/SingleMenu/singlemenu';
import PropTypes from 'prop-types';
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import '../../../feature-module/pages/menus/MyButton.css';
// import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AddOrder = ({ article, menu, show, onHide, onOrderSuccess}) => {
    // const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [DetailOrder, setDetailOrder] = useState(null);
    const MySwal = withReactContent(Swal);
    const devise = JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise;
    const [, setAllComplements] = useState([]);

    //pour recuprer les elements du formulaire
    const [formData, setFormData] = useState({
        "commentaire": " ",
        "prix_unitaire": 0,
        "quantite": 1,
        "complements": [],
    });

    const [selectedComplements, setSelectedComplements] = useState({});
    const [complementsList, setComplementsList] = useState([]);
    const [complementGroups, setComplementGroups] = useState([]);
    // Calculer le nombre total de compléments gratuits
    const totalNbreGratuit = complementGroups.reduce((total, group) => total + (group.nbre_gratuit || 0), 0);
    // Calculer le max par groupe
    const getMaxComplementsForGroup = (groupId) => {
        const group = complementGroups.find(g => g.id_complement_group === groupId);
        return group ? group.nbre_gratuit * formData.quantite : 0;
    };

    useEffect(() => {
         if (article && article.complement_groups && Array.isArray(article.complement_groups)) {

             // Filtrer les groupes uniques par id_complement_group
            const complementsGroups = article.complement_groups.filter(
                (group, index, self) => 
                    index === self.findIndex(g => g.id_complement_group === group.id_complement_group)
            );
            // Extraire tous les compléments de tous les groupes pour la liste
            const allComplements = [];
            const groups = complementsGroups.map(group => {
                const groupComplements = group.complements.map(comp => ({
                    id: comp.id_complement,
                    nom: comp.nom,
                    prix_unitaire: comp.prix || 0,
                    disponibilite: comp.disponibilite,
                    id_complement_group: group.id_complement_group,
                    group_nom: group.nom
                }));
                allComplements.push(...groupComplements);
                
                return {
                    id_complement_group: group.id_complement_group,
                    nom: group.nom,
                    id_article_complement_group: group.id_article_complement_group,
                    nbre_gratuit: group.nbre_gratuit,
                    complements: groupComplements
                };
            });
            
            setComplementGroups(groups);
            setComplementsList(allComplements);
            setAllComplements(allComplements);
            console.log("Groupes de compléments chargés:", groups);
            console.log(" Tous les compléments:", allComplements);
        }
    }, [article]);

    useEffect(() => {
        if (article) {
            setFormData((prev) => ({
                ...prev,
                prix_unitaire: article.prix_unitaire,
            }));
            setSelectedComplements({});
        }
    }, [article]);

    useEffect(() => {
    const complementsArray = [];
        Object.entries(selectedComplements).forEach(([id, quantity]) => {
            const complement = complementsList.find(c => c.id === parseInt(id));
            if (complement && quantity > 0) {
                const group = complementGroups.find(g => g.id_complement_group === complement.id_complement_group);
                const nbreGratuitGroup = group?.nbre_gratuit || 0;
                complementsArray.push({
                    id_complement: complement.id,
                    id_complement_group: complement.id_complement_group,
                    nbre_gratuit: nbreGratuitGroup,
                    prix: complement.prix_unitaire || 0,
                    quantite: quantity
                });
            }
        });
        
        setFormData(prev => ({
            ...prev,
            complements: complementsArray
        }));
    }, [selectedComplements, complementsList]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "quantite" ? Number(value) : value,
        }));
    };

    // Compter le nombre de compléments facturés dans un groupe
    const getPaidCountInGroup = (groupId) => {
        const group = complementGroups.find(g => g.id_complement_group === groupId);
        if (!group) return 0;
        
        const maxGratuits = group.nbre_gratuit * formData.quantite;
        let totalSelected = 0;
        
        // Compter tous les compléments sélectionnés dans ce groupe
        Object.entries(selectedComplements).forEach(([id, quantity]) => {
            const complement = group.complements.find(c => c.id === parseInt(id));
            if (complement && quantity > 0) {
                totalSelected += quantity;
            }
        });
        
        // Si le nombre sélectionné dépasse les gratuits, le reste est facturé
        return Math.max(0, totalSelected - maxGratuits);
    };

    // Gérer la sélection d'un complément
    const handleComplementSelect = async (complementId, groupId) => {
        if (complementId === "") return;
        if (selectedComplements[complementId]) {
            return;
        }

        const group = complementGroups.find(g => g.id_complement_group === groupId);
        if (!group) return;
          
        // Ajouter le complément avec quantité 1
        setSelectedComplements(prev => ({
            ...prev,
            [complementId]: 1
        }));
    };

    // Supprimer un complément sélectionné
    const removeComplement = (complementId) => {
        const newSelected = { ...selectedComplements };
        delete newSelected[complementId];
        setSelectedComplements(newSelected);
    };

    const incrementComplement = async (complementId, groupId) => {
        const group = complementGroups.find(g => g.id_complement_group === groupId);
        if (!group) return;
    
        setSelectedComplements(prev => ({
            ...prev,
            [complementId]: (prev[complementId] || 0) + 1
        }));
    };

    const decrementComplement = (complementId) => {
        const currentQty = selectedComplements[complementId] || 0;
        if (currentQty <= 1) {
            // Si quantité <= 1, on supprime le complément
            removeComplement(complementId);
        } else {
            setSelectedComplements(prev => ({
                ...prev,
                [complementId]: prev[complementId] - 1
            }));
        }
    };


     const isComplementSelected = (complementId) => {
        return selectedComplements[complementId] !== undefined;
    };


    const handleSubmit = async (e, article) => {
        e.preventDefault(); // éviter le rechargement de la page
        setLoading(true);
        const reference = JSON.parse(sessionStorage.getItem("client"))?.reference;

         // Construire le payload avec le tableau complements
        const payload = {
            commentaire: formData.commentaire,
            prix_unitaire: formData.prix_unitaire,
            quantite: formData.quantite,
            nb_complement: article.nb_complement,
            complements: formData.complements // Ajout du tableau de compléments
        };

        try {
            const response = await axios.post(`${base_api_url}api/detailscmd/${article.id_article}/${menu?.id_menu}/${reference}`, payload)
            console.log("Réponse de l'api :", response.data);

            // Handle successful responses (200, 201)
            if (response.status === 200 || response.status === 201) {
                setDetailOrder(response.data);

                // Fetch updated order details
                await fetchOrderDetails(reference);

                // Show success notification
                MySwal.fire({
                    icon: "success",
                    // title: "Article ajouté !",
                    text: "Votre article a bien été ajouté au panier !",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });

                onHide(); // Close modal and stay on homemenu
            }

        } catch (error) {
            console.error("Error adding article to order:", error);

            //             let errorTitle = "Erreur d'ajout";
            let errorMessage = "Impossible d'ajouter l'article au panier.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 400:
                        //                         errorTitle = "Données invalides";
                        if (errorData?.message?.includes("quantite")) {
                            errorMessage = "La quantité doit être un nombre valide supérieur à 0.";
                        } else {
                            errorMessage = errorData?.message || "Les données saisies ne sont pas valides.";
                        }
                        break;

                    case 401:
                        //                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Veuillez rafraîchir la page.";
                        break;

                    case 404:
                        //                         errorTitle = "Article introuvable";
                        errorMessage = "Cet article n'est plus disponible ou n'existe pas dans ce menu.";
                        break;

                    case 409:
                        //                         errorTitle = "Article déjà dans le panier";
                        errorMessage = "Cet article est déjà dans votre panier. Modifiez la quantité depuis le panier.";
                        break;

                    case 422:
                        //                         errorTitle = "Commande invalide";
                        errorMessage = errorData?.message || "Impossible d'ajouter cet article à votre commande.";
                        break;

                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
                        break;

                    case 503:
                        //                         errorTitle = "Service indisponible";
                        errorMessage = "Le service de commande est temporairement indisponible.";
                        break;

                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite.";
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
            }

            // Show error notification
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        }
        finally {
            setLoading(false);
        }
    };

    const totalPaidCount = complementGroups.reduce((total, group) => {
        return total + getPaidCountInGroup(group.id_complement_group);
    }, 0);

    // Fetch order details to get total quantity
    const fetchOrderDetails = async (reference) => {
        try {
            const response = await axios.get(`${base_api_url}api/commande/${reference}`);

            // Handle successful responses (200, 201)
            if (response.status === 200 || response.status === 201) {
                console.log("Order details:", response.data);

                // Calculate total quantity from all order details
                const totalQuantity = response.data.Details?.reduce((total, detail) => {
                    return total + (detail.quantite || 0);
                }, 0) || 0;

                // Call parent callback with the total quantity
                if (onOrderSuccess) {
                    onOrderSuccess(totalQuantity);
                }
            }

        } catch (error) {
            console.error("Error fetching order details:", error);

            //             let errorTitle = "Erreur de mise à jour du panier";
            let errorMessage = "Impossible de mettre à jour la quantité du panier.";
            let showError = true;

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 404:
                        // Order not found - this might be normal, set quantity to 0 silently
                        console.log("Order not found during fetch - this might be expected");
                        if (onOrderSuccess) {
                            onOrderSuccess(0);
                        }
                        showError = false;
                        break;

                    case 401:
                        //                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Veuillez rafraîchir la page.";
                        break;

                    case 403:
                        //                         errorTitle = "Accès refusé";
                        errorMessage = "Vous n'avez pas accès à cette commande.";
                        break;

                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur lors de la mise à jour du panier.";
                        break;

                    case 503:
                        //                         errorTitle = "Service indisponible";
                        errorMessage = "Le service est temporairement indisponible.";
                        break;

                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors de la mise à jour du panier.";
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur pour mettre à jour le panier.";
            }

            // Show error notification only for actual errors
            if (showError) {
                MySwal.fire({
                    icon: "warning",
                    // title: errorTitle,
                    text: errorMessage,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });
            }

            // Set default quantity on error (except for 404 which is handled above)
            if (error.response?.status !== 404 && onOrderSuccess) {
                onOrderSuccess(0);
            }
        }
    };

    console.log("le detail de la commande", DetailOrder)
    console.log("MODAL", show, article);
    if (!show || !article) return null;

    const totalSelected = Object.values(selectedComplements).reduce((sum, qty) => sum + qty, 0);

    return (
        <>
            <div
                className="modal show fade"
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
                style={{
                    display: "block",
                    background: "rgba(0,0,0,0.45)",
                    zIndex: 9999,
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    overflow: "hidden",
                }}
            >
                <div
                    className="modal-dialog"
                    style={{
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: "100vw",            // full viewport width
                        padding: 0,                // no side gap to ensure true full width
                        boxSizing: "border-box",
                        margin: 0,
                        zIndex: 10000,
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            width: "100vw",           // ensure content spans full viewport width
                            margin: 0,
                            borderRadius: 16,
                            padding: 20,
                            background: "#fff",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                            position: "relative",
                            overflow: "hidden",
                        }}
                    >
                        {/* close button */}
                        <button
                            type="button"
                            aria-label="Fermer"
                            onClick={onHide}
                            style={{
                                position: "absolute",
                                top: 12,
                                right: 12,
                                background: "transparent",
                                border: "none",
                                fontSize: 20,
                                cursor: "pointer",
                                color: "#333",
                            }}
                        >
                            ×
                        </button>

                        {/* top image (centered) */}
                        <div style={{ display: "flex", justifyContent: "center", marginTop: 6 }}>
                            <div
                                style={{
                                    width: 128,
                                    height: 127,
                                    borderRadius: 12,
                                    overflow: "hidden",
                                    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                                }}
                            >
                                <ImageWithBasePath
                                    src={article.image_url}
                                    alt={article.nom}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>
                        </div>

                        {/* title + rating */}
                        <div style={{ marginTop: 12, textAlign: "left", padding: "0 6px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <h3 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: "#222" }}>
                                    {article.nom}
                                </h3>
                                <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#666", fontSize: 14 }}>
                                    <span style={{ color: "#ff9900", fontSize: 16 }}>★</span>
                                    <span>({article.note ?? article.rating ?? "4,6"})</span>
                                </div>
                            </div>

                            <p style={{ marginTop: 8, marginBottom: 6, color: "#777", fontSize: 14, lineHeight: 1.3 }}>
                                {article.description}
                            </p>    
                        </div>

                        {/* quantity control */}
                        <div style={{ display: "flex", marginTop: 12 }}>
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    background: "#f4f4f6",
                                    borderRadius: 999,
                                    padding: "6px 10px",
                                    gap: 10,
                                }}
                            >
                                <button
                                    type="button"
                                    onClick={() => setFormData((p) => ({ ...p, quantite: Math.max(1, (p.quantite || 1) - 1) }))}
                                    style={{
                                        width: 34,
                                        height: 34,
                                        borderRadius: "50%",
                                        border: "none",
                                        background: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                        fontSize: 20,
                                        color: "#333",
                                    }}
                                >
                                    −
                                </button>

                                <input
                                    name="quantite"
                                    type="number"
                                    value={formData.quantite}
                                    onChange={handleChange}
                                    min={1}
                                    onBlur={() => { if (!formData.quantite || formData.quantite < 1) setFormData(p => ({ ...p, quantite: 1 })); }}
                                    style={{
                                        width: 44,
                                        textAlign: "center",
                                        fontWeight: 600,
                                        border: "none",
                                        background: "transparent",
                                        outline: "none",
                                        fontSize: 16,
                                    }}
                                />

                                <button
                                    type="button"
                                    onClick={() => setFormData((p) => ({ ...p, quantite: (p.quantite || 1) + 1 }))}
                                    style={{
                                        width: 34,
                                        height: 34,
                                        borderRadius: "50%",
                                        border: "none",
                                        background: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                        fontSize: 18,
                                        color: "#333",
                                    }}
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        {complementsList.length > 0 && (
                            <div style={{ marginTop: 20 }}>
                                <h5 style={{ marginBottom: 12, fontSize: 16, fontWeight: 600, color: "#333" }}>
                                    Choisissez vos accompagnements ({totalSelected}/{totalNbreGratuit})
                                     {totalPaidCount > 0 && (
                                        <span style={{ fontSize: 13, fontWeight: 600, color: "#E7592C", marginLeft: 8 }}>
                                            ({totalPaidCount} facturé{totalPaidCount > 1 ? 's' : ''})
                                        </span>
                                    )}
                                </h5>

                                {complementGroups.map((group) => {
                                     const paidCount = getPaidCountInGroup(group.id_complement_group);
                                    return (
                                        <div key={group.id_complement_group} style={{ marginBottom: 20 }}>
                                            <h6 style={{ 
                                                fontSize: 14, 
                                                fontWeight: 600, 
                                                color: "#555",
                                                marginBottom: 10,
                                                paddingBottom: 6,
                                                borderBottom: "2px solid #f0f0f0"
                                            }}>
                                                {group.nom} 
                                                <span style={{ 
                                                    fontSize: 12, 
                                                    fontWeight: 400, 
                                                    color: "#888",
                                                    marginLeft: 8
                                                }}>
                                                    ({group.complements.length} choix disponibles)
                                                </span>
                                                {group.nbre_gratuit > 0 && (
                                                    <span style={{ 
                                                        fontSize: 12, 
                                                        fontWeight: 500, 
                                                        color: "#16a34a",
                                                        marginLeft: 8,
                                                        backgroundColor: "#dcfce7",
                                                        padding: "2px 8px",
                                                        borderRadius: 12
                                                    }}>
                                                        {getMaxComplementsForGroup(group.id_complement_group)} gratuit{getMaxComplementsForGroup(group.id_complement_group) > 1 ? 's' : ''}
                                                    </span>         
                                                )}                        
                                                 {paidCount > 0 && (
                                                    <span style={{ 
                                                        fontSize: 12, 
                                                        fontWeight: 600, 
                                                        color: "#E7592C",
                                                        backgroundColor: "#fee2e2",
                                                        padding: "2px 8px",
                                                        borderRadius: 12
                                                    }}>
                                                        {paidCount} facturé{paidCount > 1 ? 's' : ''}
                                                    </span>
                                                )}
                                            </h6>

                                            {/* Pill chips for selection */}
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
                                                {group.complements.map(comp => {
                                                    const isSelected = isComplementSelected(comp.id);
                                                    return (
                                                        <button
                                                            key={comp.id}
                                                            type="button"
                                                            onClick={() => {
                                                                if (isSelected) {
                                                                    removeComplement(comp.id);
                                                                } else {
                                                                    handleComplementSelect(comp.id, group.id_complement_group);
                                                                }
                                                            }}
                                                            style={{
                                                                padding: "8px 16px",
                                                                borderRadius: "20px",
                                                                border: isSelected ? "2.5px solid #FF6A3D" : "1.5px solid #e2e8f0",
                                                                backgroundColor: isSelected ? "#FFF4F0" : "#fff",
                                                                color: isSelected ? "#FF6A3D" : "#334155",
                                                                fontWeight: isSelected ? "700" : "500",
                                                                fontSize: "14px",
                                                                cursor: "pointer",
                                                                transition: "all 0.15s ease",
                                                                boxShadow: isSelected ? "0 2px 8px rgba(255,106,61,0.12)" : "none"
                                                            }}
                                                        >
                                                            {comp.nom} {comp.prix_unitaire ? `(+${comp.prix_unitaire} ${devise || ''})` : ''}
                                                            {comp.disponibilite === false && ' (indisponible)'}
                                                        </button>
                                                    );
                                                })}
                                            </div>

                                         {/* ✅ Liste des compléments sélectionnés */}
                                            {Object.entries(selectedComplements)
                                                .filter(([id]) => group.complements.some(c => c.id === parseInt(id)))
                                                .map(([id, quantity]) => {
                                                    const complement = group.complements.find(c => c.id === parseInt(id));
                                                    if (!complement) return null;
                                                    return (
                                                        <div
                                                            key={id}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                marginBottom: 10,
                                                                padding: '8px 12px',
                                                                backgroundColor: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                border: '1px solid #e9ecef'
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                <span style={{ fontSize: 15, color: '#333', fontWeight: 500 }}>
                                                                    {complement.nom}
                                                                </span>
                                                                <span style={{ fontSize: 13, color: '#888' }}>
                                                                    (+{complement.prix_unitaire} {devise})
                                                                </span>
                                                            </div>
                                                            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => decrementComplement(parseInt(id))}
                                                                    style={{
                                                                        width: 30,
                                                                        height: 30,
                                                                        borderRadius: '50%',
                                                                        border: '1px solid #ddd',
                                                                        background: '#fff',
                                                                        cursor: 'pointer',
                                                                        fontSize: 16,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    -
                                                                </button>
                                                                <span style={{ fontSize: 15, fontWeight: 600, minWidth: 20, textAlign: 'center' }}>
                                                                    {quantity}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => incrementComplement(parseInt(id), group.id_complement_group)}
                                                                    style={{
                                                                        width: 30,
                                                                        height: 30,
                                                                        borderRadius: '50%',
                                                                        border: '1px solid #ddd',
                                                                        background:  '#fff',
                                                                        cursor:'pointer',
                                                                        fontSize: 16,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        opacity: totalSelected >= getMaxComplementsForGroup(group.id_complement_group) + 10 ? 0.5 : 1
                                                                    }}
                                                                >
                                                                    +
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => removeComplement(parseInt(id))}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        color: '#dc3545',
                                                                        fontSize: 18,
                                                                        cursor: 'pointer',
                                                                        padding: '0 4px'
                                                                    }}
                                                                >
                                                                    ×
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* submit area */}
                        <form onSubmit={(e) => handleSubmit(e, article)}>
                            <div style={{ marginTop: 18 }}>
                                {(() => {
                                    // Compute extra cost from paid complements
                                    const extraCost = Object.entries(selectedComplements).reduce((sum, [id, qty]) => {
                                        const comp = complementsList.find(c => c.id === parseInt(id));
                                        if (!comp || qty <= 0) return sum;
                                        const group = complementGroups.find(g => g.id_complement_group === comp.id_complement_group);
                                        const freeQty = group ? group.nbre_gratuit * formData.quantite : 0;
                                        const totalSelectedInGroup = Object.entries(selectedComplements).reduce((s, [cid, cqty]) => {
                                            const cc = complementGroups.find(g => g.id_complement_group === comp.id_complement_group)?.complements.find(x => x.id === parseInt(cid));
                                            return cc ? s + cqty : s;
                                        }, 0);
                                        const paidForThisComp = Math.max(0, Math.min(qty, totalSelectedInGroup - freeQty));
                                        return sum + paidForThisComp * (comp.prix_unitaire || 0);
                                    }, 0);
                                    const basePrice = article.prix_unitaire * formData.quantite;
                                    const totalPrice = basePrice + extraCost;

                                    return (
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                background: loading ? "#f5f5f7" : "#FDE7DF",
                                                border: "none",
                                                padding: "14px 16px",
                                                borderRadius: 14,
                                                color: loading ? "#aaa" : "#E7592C",
                                                fontWeight: 700,
                                                fontSize: 16,
                                                cursor: loading ? "not-allowed" : "pointer",
                                                transition: "background 0.2s",
                                            }}
                                        >
                                            <span>{loading ? "Ajout en cours..." : "Ajouter à ma commande"}</span>
                                            <span style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1 }}>
                                                <span style={{ fontWeight: 700, fontSize: 16 }}>
                                                    {totalPrice.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} {devise}
                                                </span>
                                                {extraCost > 0 && (
                                                    <span style={{ fontSize: 11, fontWeight: 500, color: "#B84A1E", fontStyle: "italic" }}>
                                                        dont +{extraCost.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} {devise} accomp.
                                                    </span>
                                                )}
                                            </span>
                                        </button>
                                    );
                                })()}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )

}
AddOrder.propTypes = {
    article: PropTypes.object.isRequired,
    menu: PropTypes.object.isRequired,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onOrderSuccess: PropTypes.func,
};

export default AddOrder;